namespace TabAurous.ECommerce {
    export var total = 0;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ECommRepairDialog extends _Ext.TransDialog<ECommRepairRow, any> {

        protected getFormKey() { return ECommRepairForm.formKey; }
        protected getIdProperty() { return ECommRepairRow.idProperty; }
        protected getLocalTextPrefix() { return ECommRepairRow.localTextPrefix; }
        protected getNameProperty() { return ECommRepairRow.nameProperty; }
        protected getService() { return ECommRepairService.baseUrl; }
        protected getDeletePermission() { return ECommRepairRow.deletePermission; }
        protected getInsertPermission() { return ECommRepairRow.insertPermission; }
        protected getUpdatePermission() { return ECommRepairRow.updatePermission; }
        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }
        protected useViewMode() { return true; }

        public form = new ECommRepairForm(this.idPrefix);
        public PartyId: number;
        public RateListId: number = 0;
        public LaborListId: number = 0;
        public StoneMarkup: number = 0;
        public StoneDiscount: number = 0;
        public LaborMarkup: number = 0;
        public LaborDiscount: number = 0;
        public ExchangeRate: number = 0;

        TaxArray: any[]; 
        //total: number;
        public total1: number;
        static giftcheck: boolean;
        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            this.element.find('.panel-titlebar-close').remove();

            this.element.siblings("panel-titlebar").find("button.panel-titlebar-close").remove()

            //$('.panel-titlebar-close').attr("style", "display:none;");
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ItemDetails); 
            q.hideEditorLabel(this.form.TaxDetails); 

            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.BalanceAmount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.Receipt);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Discount);
            //q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 250); 
            q.hideEditorToolbar(this.form.TaxDetails);//To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ImageName);
            q.SetCategoryFullWidth(this.form.ItemDetails); 
            q.SetSix12Column(this.form.TaxDetails);

            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategorySixColumn(this.form.Remark);
            q.HideCategoryLable(this.element);
            q.setTextRightAlign(this.form.RoundOff);
            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value = this.form.GrossAmount.value + this.form.RoundOff.value;
            });

            q.hideCaption(this.form.CustomerName);

            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150; 
            this.form.POSCustomerId.changeSelect2(e => {
                var cid = parseInt(this.form.POSCustomerId.value);

                if (cid > 0) {
                    let CustomerDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: cid }, response => { CustomerDetails = response.Entity }, { async: false }); 
                    this.form.POSCustomerId.value = CustomerDetails.POSCustomerId.toString();
                    this.form.Address.value = CustomerDetails.Address;
                    this.form.BirthDate.value = CustomerDetails.BirthDate;
                    this.form.Anniversary.value = CustomerDetails.Anniversary;
                    this.form.Mobile.value = parseFloat(CustomerDetails.Mobile);
                    this.form.PanNumber.value = CustomerDetails.PanNumber;
                    this.form.TaxId.value = CustomerDetails.TaxId;
                }
            });

            this.form.EmployeeId.changeSelect2(e => {
                this.form.ItemDetails.salespersonId = parseInt(this.form.EmployeeId.value);               

            })

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any; 
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);

                this.forOrderAdvance(Items);
            })



            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
                //alert(total);

            });
            this.form.GrossAmount.change(e => {
                this.form.NetAmount.value = this.form.GrossAmount.value;
            });

            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value + this.form.RoundOff.value;
            })

            this.validateForm();

        }
        forOrderAdvance(Items: ECommRepairItemsRow[]) {
            if (!this.isViewMode()) {
                var transids = [];
                for (var i = 0; i < Items.length; i++) {
                    if (Items[i].RefVoucherId == 47) {
                        transids.push(Items[i].RefTransId);
                    }
                }
                let advances = [];
                if (this.form.ItemDetails.getItems().length > 0) {
                    ReceiptService.GetAdvanceList({ TransIds: transids }, response => advances = response.Entities,
                        {
                            async: false
                        });

                    
                }
            }

        }

        // **** Total Weight, Amount and TAX Calculation ****
        CalculateAmountandTax(Items: ECommRepairItemsRow[], TotalItems: number) {
            if (!this.isViewMode()) {

                var HSN = [];
                var Amount = [];
                var TaxDetail = [];
                var ItemTotal = 0; 
                var ProductType = [];
                var ProductAmount = [];
                var ProductLabour = [];
                var Promos = [];

                var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0; var giftAmount = 0;

                for (var x of Items) {
                    ntamt += x.NetAmount || 0;
                    gramt += x.GrossAmount || 0;
                    disc += x.Discount || 0;
                    pcs += x.Pieces || 0;
                    wt += x.Weight || 0;
                    nwt += x.NetWeight || 0;

                    var temp = false;
                    for (let i = 0; i < HSN.length; i++) {
                        if (HSN[i] == x.TaxCode) {
                            Amount[i] += x.GrossAmount || 0;
                            temp = true;
                        }
                    }

                    if (!temp) {
                        HSN.push(x.TaxCode);
                        Amount.push(x.GrossAmount);
                    }

                    // **** To calculate Values for Promotion ****
                    if (x.ProductTypeId != null) {
                        var temp = false;
                        for (let i = 0; i < ProductType.length; i++) {
                            if (ProductType[i] == x.ProductTypeId) {
                                ProductAmount[i] += x.GrossAmount || 0;
                                ProductLabour[i] += x.UnitLabour || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            ProductType.push(x.ProductTypeId);
                            ProductAmount.push(x.GrossAmount);
                            ProductLabour.push(x.UnitLabour);
                        }
                    }

                    ItemTotal++;
                };


               
                this.form.NetAmount.value = gramt; 
               

                var TaxAmount = 0;

                var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

                if (ItemTotal == TotalItems && TaxApplicable) {

                    var TaxItems = this.form.TaxDetails.getItems().length;
                    var it = this.form.TaxDetails.getItems();
                    if (TaxItems > 0) {
                        this.form.TaxDetails.DeleteTax();
                    }

                    //TODO: Get Company Country to Call appropriate TAX Helper

                    TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, false, 1);

                    //Get Taxes for Voucher
                    TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, false);

                    var temp2 = this.form.TaxDetails.getData(TaxDetail);
                    this.form.TaxDetails.view.setItems(temp2, true);

                    TaxDetail.forEach(function (value) {
                        if (value.TaxType != "TDS")
                            TaxAmount += value.TaxAmount;
                        else
                            tds += value.TaxAmount;

                    });

                    this.form.TaxAmount.value = TaxAmount;
                    this.form.GrossAmount.value = gramt + TaxAmount ;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }
                else {
                     this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }
                 
                this.form.GrossAmount.value += giftAmount;


                if (this.form.GrossAmount.value > 0) {
                    if (this.form.Receipt.value == undefined)
                        this.form.Receipt.value = 0;

                    this.form.BalanceAmount.value = this.form.GrossAmount.value - this.form.Receipt.value;
                }
            }
        }
         

        protected onDialogOpen() {
            super.onDialogOpen();

            var fieldEditor: JQuery = this.form.POSCustomerId.element.closest(".editor");

            fieldEditor.addClass("has-inplace-button");
            $('<a><b/>...</a>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.PosCustomerMasterGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Customer"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.PosCustomerMasterRow[]) => {

                this.form.POSCustomerId.value = selectedItems[0].POSCustomerId.toString();
                this.form.Address.value = selectedItems[0].Address;
                this.form.BirthDate.value = selectedItems[0].BirthDate;
                this.form.Anniversary.value = selectedItems[0].Anniversary;
                this.form.Mobile.value = parseFloat(selectedItems[0].Mobile);
                this.form.PanNumber.value = selectedItems[0].PanNumber;
                this.form.TaxId.value = selectedItems[0].TaxId;
            }
            pickerDialog.dialogOpen();

        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            //this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());

            var CompanyDetails = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId];
            if (CompanyDetails.IsPriceList) {
                this.RateListId = CompanyDetails.SPriceListId || 0;
                this.StoneMarkup = CompanyDetails.SMarkup|| 0;
            }

            if (CompanyDetails.IsLabourList) {
                this.LaborListId = CompanyDetails.SLabourListId||0;
                this.LaborMarkup = CompanyDetails.SLMarkup||0;
            }

          
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
            //var reportoptions: _Ext.ReportExecuteOptions = {
                
            //}
            //Export PDF Button
            btns.push(_Ext.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                reportKey: 'ECommerce.ECommRepairVoucher',
                
                getParams: () => ({
                    TransID: this.get_entityId()
                }),
            })); 
            return btns;
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            }  
            else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                ECommRepairService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        } 
        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }
            for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
                let items = this.form.ItemDetails.getItems();
                items[i].BOMDetails.forEach(function (x) {
                    if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component "' + items[i].ProductCode + '", Cannot Save!');
                        Q.alert(msg)
                        Isvalid = false;
                        return;
                    }
                })

                if (items[i].LaborDetails!=undefined &&items[i].LaborDetails.length > 0) {
                    items[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null|| x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labor, Can not Save!")
                            Isvalid = false;
                            return;
                        }
                    })
                }
            }

            total = this.form.Receipt.value;
            if ((total + this.form.BalanceAmount.value) !== parseFloat(this.form.GrossAmount.value.toString())) {


                Q.confirm('Payments and Gross Amount do not match.. Do you want to add the balance as Credit', () => {
                    var dialog = new AuthorizeDialog();
                    dialog.inst = this;
                    dialog.entityId = this.entity.TransId;
                    dialog.voucherno = this.form.VoucherNo.value;
                    dialog.vouchertypeid = this.form.VoucherTypeId.value;


                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {
                            this.form.BalanceAmount.value = this.form.GrossAmount.value - total;
                            this.save();
                            this.dialogClose();
                            Isvalid = true;

                        }
                    });
                    dialog.dialogOpen();
                }, {});
            } else if ((total + this.form.BalanceAmount.value) == parseFloat(this.form.GrossAmount.value.toString())) {
                Isvalid = true;
                return;
            }
            else {
                Isvalid = false;
                return;
            }

            return Isvalid;

        }

    }
}